import React from "react";
import { useTranslation } from "react-i18next";
import { NeonRace, PortfolioItemData } from "./Portfolio";
import {StudioGame} from "./StudioGame";
import styles from "../../assets/css/OurProject.module.css";

export const OurProject = () => {
  const studioGames: Array<PortfolioItemData> = [
    NeonRace
  ];

  const { t } = useTranslation();
  return (
    <>
      <div className={styles.gameswrapper}>
        <div className={styles.gamesitemsRow}>
          {studioGames.map((item, index) => <StudioGame key={index} {...item} limit={370} />)}
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.wrap}>
          <img
            src={window.location.origin + "/img/project_announce.png"}
            alt="announce cat"
          />
          <p className={styles.text}>
            {t("Preparing")}
            <br />
            {t("Something interesting")}
          </p>
        </div>
      </div>
    </>

  );
};
